import { instanceAxios } from "./axios";

const sanitizeAllFields = (data) => {
  for (let key in data) {
    if (
      Object.prototype.hasOwnProperty.call(data, key) &&
      typeof data[key] === "string"
    ) {
      data[key] = data[key].replace(/'on'/g, "on");
    }
  }
  return data;
};

export const post = (url, data = {}, sourceToken) => {
  data = sanitizeAllFields(data);
  return instanceAxios.post(url, data, {
    cancelToken: sourceToken && sourceToken.token,
  });
};
export const get = (url, params = {}) =>
  instanceAxios.get(encodeURI(url), { params });
export const put = (url, data = {}) => instanceAxios.put(url, data);
export const deleteApi = (url, data = {}) => instanceAxios.delete(url, data);
